import { Text } from '../Text';
import { styled } from 'styled-components';
import { breakpoints } from '../../abstracts';
export const FileUploaderContainer = styled.div.withConfig({
  componentId: "aui__sc-s73s0c-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;overflow-wrap:break-word;", "{width:19.5rem;}"], breakpoints.sm);
export const Title = styled(Text).attrs({
  forwardedAs: 'h2',
  weight: 'base',
  size: 3
}).withConfig({
  componentId: "aui__sc-s73s0c-1"
})(["text-align:left;align-self:flex-start;max-width:fit-content;margin:1rem 0;"]);